import { ListHeaderCellType } from "views/components/atoms/listCell";
import { ListHeaderType } from "views/components/molecules/listHeader";

export type DocumentGrantData = {
  // 書類区分
  documentType: string;
  // 書面ID
  documentId: string;
  // 口座番号
  accountNumber: string;
  // ファイル名
  fileName: string;
  // 交付日
  deliveryDate: string;
};

export type DocumentGrantResponse = {
  total: number;
  documentGrandList: DocumentGrantData[];
};

export type GetDocumentGrantRequestParam = {
  page: number;
  limit: number;
  fileName: string;
  // 交付書面種別
  documentType: string;
};

export const DocumentGrandHeaderShowList: ListHeaderType[] = [
  {
    type: ListHeaderCellType.textCell,
    label: "選択",
  },
  {
    type: ListHeaderCellType.sentenceCell,
    label: "ファイル名",
  },

  {
    type: ListHeaderCellType.textCell,
    label: "交付日",
  },
];
